export const contentStyles = theme => ({
  display: 'grid',
  gridRowGap: theme.spacing(1),
  gridTemplateColumns: '1fr 40px',
  padding: theme.spacing(1, 3, 2),
});

export const detailCol2Styles = {
  gridColumn: '2',
  justifySelf: 'end',
};

export const detailLabelStyles = theme => ({
  gridColumn: '1 / span 2',
  paddingTop: theme.spacing(1),
});

export const iconContainerStyles = {
  minWidth: 34,
  padding: 0,
};

export const tooltipStyles = theme => ({
  fontSize: 12,
  padding: theme.spacing(1.5),
});

export const tooltipLinkStyles = {
  color: 'inherit',
  fontSize: 14,
};

export const withBottomPaddingStyles = theme => ({
  paddingBottom: theme.spacing(2),
});

export const withLeftPaddingStyles = theme => ({
  paddingLeft: theme.spacing(2),
  whiteSpace: 'noWrap',
});
